import LoginPrd from '../LoginPrd'
import LoginStg from '../LoginStg'

// PRD環境：LoginPrd
// DEV/STG環境：LoginStg
const Login = () => {
    if (process.env.REACT_APP_ENV === 'prod') {
        return <LoginPrd />
    }
    return <LoginStg />
}

export default Login
